import './style.scss'

function ContentContainer({ pageRef, contentTest, urlPath, setUrlPath, deviceType, retryKey }) {
  const id = 'content_test_editor_iframe'
  const title = 'Content Editor'

  if (!contentTest) return <></>

  return (
    <div className="ContentContainer">
      <iframe
        key={`${retryKey}:${urlPath}`}
        className={deviceType === 'desktop' ? 'DesktopFrame' : deviceType === 'tablet' ? 'TabletFrame' : 'MobileFrame'}
        ref={pageRef}
        id={id}
        name={id}
        title={title}
        sandbox="allow-scripts"
        src={`${contentTest.storeURLForIframe}?${new URLSearchParams({ path_url: urlPath })}`}
        onLoad={() => pageRef.current?.contentWindow?.postMessage({ source: 'trident-preview', type: 'check' }, '*')}
      />
    </div>
  )
}

export default ContentContainer
